import { api } from '../../../api';

export type ApiKey = {
  _id: string;
  name: string;
  description?: string;
  prefix: string;
  status: 'active' | 'revoked' | 'expired';
  expiresAt?: string;
  lastUsedAt?: string;
  usageCount: number;
  createdAt: string;
};

export type CreateApiKeyResponse = ApiKey & { key: string };

type CreateApiKeyInput = {
  name: string;
  description?: string;
  expiresAt?: string;
};

export const fetchApiKeys = async (): Promise<ApiKey[]> => {
  const response = await api.get<ApiKey[]>('/api-keys');
  return response.data;
};

export const createApiKey = async (input: CreateApiKeyInput): Promise<CreateApiKeyResponse> => {
  const response = await api.post<CreateApiKeyResponse>('/api-keys', input);
  return response.data;
};

export const revokeApiKey = async (apiKeyId: string): Promise<void> => {
  await api.delete(`/api-keys/${apiKeyId}`);
};
